import React from 'react';
import "./page.css";

const TermsPage = () => {
  return (
    <div className='page-container'>
      <h1 className="terms-heading">Terms and Conditions :</h1>
      <div className='terms-content'>
      <h2 className='para-h2'>Acceptance of Terms:</h2>
      <p className='terms-para'>Clearly state that by accessing and using the website, users agree to comply with the terms and conditions outlined.</p>
      <h2 className='para-h2'>User Obligations:</h2>
      <p className='terms-para'>Outline the responsibilities and obligations of the users, such as providing accurate information, respecting intellectual property rights, and adhering to applicable laws and regulations.</p>
      <h2 className='para-h2'>Service Description:</h2>
      <p className='terms-para'>Describe the features and functionality of the Queue Management service provided on the website.</p>
      <h2 className='para-h2'>Account Creation:</h2>
      <p className='terms-para'> Explain the process of creating an account, including any registration requirements, account security measures, and user account termination policies.</p>
      <h2 className='para-h2'>Use of Service:</h2>
      <p className='terms-para'>Specify the permitted and prohibited uses of the Queue Management service, including any restrictions on activities or content that may violate the law or infringe upon the rights of others.</p>
      <h2 className='para-h2'>Privacy and Data Protection:</h2>
      <p className='terms-para'>Detail how user information and data will be collected, stored, and used, including any sharing of data with third parties and adherence to applicable privacy laws.</p>
      <h2 className='para-h2'>Intellectual Property: </h2>
      <p className='terms-para'> Clarify ownership and usage rights of the website's content, trademarks, logos, and other intellectual property.</p>
      <h2 className='para-h2'>Limitations of Liability:</h2>
      <p className='terms-para'>Disclaim any liability for damages, losses, or errors arising from the use of the Queue Management service or the website.</p>
      <h2 className='para-h2'>Termination and Suspension: </h2>
      <p className='terms-para'>Explain the circumstances under which the website or service may be terminated or suspended, and the consequences of such actions.</p>
      <h2 className='para-h2'>Modifications:</h2>
      <p className='terms-para'>Reserve the right to modify or update the terms and conditions, and specify how users will be notified of any changes.</p>
      <h2 className='para-h2'>Governing Law and Jurisdiction: </h2>
      <p className='terms-para'> Indicate the governing law and jurisdiction that will apply to any disputes arising from the use of the website or service.</p>
      </div>
    </div>
  );
};

export default TermsPage;
